import { render, staticRenderFns } from "./TemplateChartFeesSales.vue?vue&type=template&id=4f894734&scoped=true&"
import script from "./TemplateChartFeesSales.vue?vue&type=script&lang=js&"
export * from "./TemplateChartFeesSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f894734",
  null
  
)

export default component.exports